import React from "react";
import { Box, Typography } from "@mui/material";

const EmptyState = ({ icon, title, description, action, py = 10 }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      py,
      px: 3,
      textAlign: "center",
    }}
  >
    {icon && (
      <Box
        sx={{
          mb: 2.5,
          width: 72,
          height: 72,
          borderRadius: "50%",
          bgcolor: "rgba(229,0,0,0.06)",
          border: "1px solid rgba(229,0,0,0.1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "rgba(0,0,0,0.22)",
          "& svg": { fontSize: 34 },
        }}
      >
        {icon}
      </Box>
    )}
    <Typography variant="h6" fontWeight={600} color="text.primary" mb={0.75}>
      {title}
    </Typography>
    {description && (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 380, lineHeight: 1.8 }}
      >
        {description}
      </Typography>
    )}
    {action && <Box mt={3}>{action}</Box>}
  </Box>
);

export default EmptyState;
